module.exports = (__webpack_require__(35344))(6624);